<template>
  <div class="open-api-auth-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('openApiAuth.title') }}</span>
        <el-button type="primary" size="small" class="float-right" @click="_openAddOpenApiAppModal">
          <i class="el-icon-plus"></i>
          {{ $t('common.add') }}
        </el-button>
      </div>

      <!-- 搜索条件 -->
      <el-form :inline="true" :model="openApiAuthInfo.conditions" class="search-form">
        <el-form-item label="应用ID">
          <el-input v-model="openApiAuthInfo.conditions.appId" placeholder="请输入应用ID"></el-input>
        </el-form-item>
        <el-form-item label="应用名称">
          <el-input v-model="openApiAuthInfo.conditions.appName" placeholder="请输入应用名称"></el-input>
        </el-form-item>
        <el-form-item :label="$t('openApiAuth.merchantName')">
          <el-select v-model="openApiAuthInfo.conditions.storeId" :placeholder="$t('openApiAuth.selectMerchant')" style="width: 200px">
            <el-option :label="$t('common.all')" value=""></el-option>
            <el-option v-for="item in openApiAuthInfo.merchants" :key="item.storeId" :label="item.name"
              :value="item.storeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="openApiAuthInfo.conditions.status" placeholder="请选择状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">{{ $t('common.search') }}</el-button>
          <el-button @click="resetForm">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table :data="openApiAuthInfo.apps" border style="width: 100%" v-loading="loading">
        <el-table-column prop="appId" :label="$t('openApiAuth.appId')" width="180" align="center" />
        <el-table-column prop="appName" :label="$t('openApiAuth.appName')" width="200" align="center" />
        <el-table-column prop="storeName" :label="$t('openApiAuth.merchantName')" width="200" align="center" />
        <el-table-column prop="storeAddress" :label="$t('openApiAuth.merchantAddress')" align="center" />
        <el-table-column prop="appKey" :label="$t('openApiAuth.appKey')" width="350" align="center">
          <template slot-scope="scope">
            <el-tooltip content="点击复制" placement="top">
              <span @click="copyText(scope.row.appKey)">{{ scope.row.appKey }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('openApiAuth.status')" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '1' ? 'success' : 'danger'">
              {{ scope.row.status === '1' ? $t('openApiAuth.enabled') : $t('openApiAuth.disabled') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('openApiAuth.createTime')" width="180" align="center">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('openApiAuth.remark')" align="center" />
        <el-table-column :label="$t('common.operation')" width="220" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="_openDetailOpenApiAppModal(scope.row)">
              {{ $t('common.detail') }}
            </el-button>
            <el-button type="text" size="small" @click="_openEditOpenApiAppModal(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button type="text" size="small" @click="_openDeleteOpenApiAppModal(scope.row)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.current"
        :page-sizes="[10, 20, 30, 50]" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
        :total="page.total" class="pagination">
      </el-pagination>
    </el-card>

    <add-open-api-app ref="addOpenApiApp" @success="handleSuccess" />
    <edit-open-api-app ref="editOpenApiApp" @success="handleSuccess" />
    <delete-open-api-app ref="deleteOpenApiApp" @success="handleSuccess" />
    <key-info-dialog ref="keyInfoDialog" />
  </div>
</template>

<script>
import { listOpenApiApps } from '@/api/system/openApiAuthApi'
import { listStores } from '@/api/admin/merchantManage/merchantManageApi'
import AddOpenApiApp from './addOpenApiApp'
import EditOpenApiApp from './editOpenApiApp'
import DeleteOpenApiApp from './deleteOpenApiApp'
import KeyInfoDialog from './keyInfoDialog'

export default {
  name: 'OpenApiAuthList',
  components: {
    AddOpenApiApp,
    EditOpenApiApp,
    DeleteOpenApiApp,
    KeyInfoDialog
  },
  data() {
    return {
      loading: false,
      openApiAuthInfo: {
        apps: [],
        merchants: [],
        conditions: {
          appId: '',
          appName: '',
          status: '',
          storeId: ''
        }
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this._listMerchants()
    this._listOpenApiApps()
  },
  methods: {
    async _listOpenApiApps() {
      try {
        this.loading = true
        const params = {
          page: this.page.current,
          row: this.page.size,
          ...this.openApiAuthInfo.conditions
        }
        const { apps, total } = await listOpenApiApps(params)
        this.openApiAuthInfo.apps = apps
        this.page.total = total
      } catch (error) {
        this.$message.error(this.$t('openApiAuth.fetchError'))
      } finally {
        this.loading = false
      }
    },
    async _listMerchants() {
      try {
        const params = {
          page: 1,
          row: 100,
          storeTypeCd: '800900000005'
        }
        const response = await listStores(params)
        this.openApiAuthInfo.merchants = response.data
      } catch (error) {
        console.log('获取商家列表失败', error)
      }
    },
    _openAddOpenApiAppModal() {
      this.$refs.addOpenApiApp.open()
    },
    _openDetailOpenApiAppModal(app) {
      this.$refs.keyInfoDialog.open(app)
    },
    _openEditOpenApiAppModal(app) {
      this.$refs.editOpenApiApp.open(app)
    },
    _openDeleteOpenApiAppModal(app) {
      this.$refs.deleteOpenApiApp.open(app)
    },
    handleSuccess(keyInfo) {
      if (keyInfo) {
        this.$refs.keyInfoDialog.open(keyInfo)
      }
      this._listOpenApiApps()
    },
    handleSearch() {
      this.page.current = 1
      this._listOpenApiApps()
    },
    resetForm() {
      this.openApiAuthInfo.conditions = {
        appId: '',
        appName: '',
        status: '',
        merchantId: ''
      }
      this.page.current = 1
      this._listOpenApiApps()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this._listOpenApiApps()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listOpenApiApps()
    },
    copyText(text) {
      const el = document.createElement('textarea')
      el.value = text
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$message.success('复制成功')
    },
    formatDateTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style lang="scss" scoped>
.open-api-auth-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .search-form {
    margin-bottom: 20px;
  }

  .pagination {
    margin-top: 20px;
    text-align: right;
  }

  .float-right {
    float: right;
  }
}
</style>